// @flow strict

export const VISION = 'Vision';
